import React, { PropTypes } from 'react';
import CancellationPolicy from './cancellation';
import GroupPolicy from './group';
import FreeOfChargePolicy from './freeofcharge';
import FamilyPolicy from './family';
import ChildPolicy from './child';
import InfantPolicy from './infant';
import R from 'ramda';

const Policy = props => {
  const { policyType, policyProps } = props;
  return R.call(R.cond([
    [R.equals('cancellation'), R.always(<CancellationPolicy {...policyProps}/>)],
    [R.equals('child'), R.always(<ChildPolicy {...policyProps}/>)],
    [R.equals('infant'), R.always(<InfantPolicy {...policyProps}/>)],
    [R.equals('group'), R.always(<GroupPolicy {...policyProps}/>)],
    [R.equals('freeOfCharge'), R.always(<FreeOfChargePolicy {...policyProps}/>)],
    [R.equals('family'), R.always(<FamilyPolicy {...policyProps}/>)],
  ]), policyType);
};

Policy.propTypes = {
  policyType: PropTypes.string,
  policyProps: PropTypes.object,
};

export default Policy;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/policies/policy-main.jsx